export default "__VITE_ASSET__C0d4KIWo__"